import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewComponent } from '../../../components/reviewCard/review.component';
@Component({
  selector: 'app-opinions',
  standalone: true,
  imports: [CommonModule, ReviewComponent],
  templateUrl: './opinions.component.html',
  styleUrl: './opinions.component.scss'
})
export class OpinionsComponent {

}
